import { create } from 'apisauce'
import { getLanguageCode } from 'config/i18n'
import { getToken } from '../auth'

export interface PartipostApiResponse<T = any> {
    data: T
    message: string
    success: boolean
}

export interface PartipostApiPaginationWrapper<T = any> {
    count: number | null
    next: string
    previous: string
    results: T
}

export const api = create({
    baseURL: `${process.env.REACT_APP_PARTIPOST_API_HOST}/cm`,
    headers: {
        Accept: 'application/json;version=1.0.0',
        'Accept-Language': getLanguageCode(),
        ...(getToken() !== undefined && getToken() !== null ? { Authorization: `Token ${getToken()}` } : {}),
    },
})
